import React from 'react';
import Button from './Button';
import { highlightKeywords } from './highlight';
import '../styles/Curriculum.css'; // 必要なら

const QAModal = ({
  show,
  onClose,
  question,
  setQuestion,
  handleAsk,
  loading,
  history
}) => {
  if (!show) return null;

  return (
    <div className="qa-modal-overlay" onClick={onClose}>
      <div className="qa-modal" onClick={(e) => e.stopPropagation()}>
        <h2>📘 カリキュラムFAQ</h2>
        <textarea
          rows={4}
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          placeholder="質問を入力してください"
          style={{ width: '100%', marginBottom: '0.5rem' }}
        />
        <Button onClick={handleAsk} disabled={loading}>
          {loading ? '回答中...' : '質問する'}
        </Button>

        <h3 style={{ marginTop: '1rem' }}>📖 回答履歴</h3>
        {history.length === 0 && <p>まだ質問がありません。</p>}

        <div style={{ maxHeight: '300px', overflowY: 'auto', marginTop: '0.5rem' }}>
          {history.map((item, idx) => (
            <div className="card" key={idx}>
              <h4>質問：</h4>
              <p>{item.question}</p>
              <h4>回答：</h4>
              <p>{highlightKeywords(item.answer, item.keywords)}</p>
              {item.keywords.length > 0 && (
                <p><strong>キーワード：</strong>{item.keywords.join(', ')}</p>
              )}
              {item.sources.length > 0 && (
                <div>
                  <h4>参考教材：</h4>
                  {item.sources.map((src, i) => (
                    <span className="source-label" key={i}>{src}</span>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        <div style={{ marginTop: '1rem', textAlign: 'right' }}>
          <Button onClick={onClose}>閉じる</Button>
        </div>
      </div>
    </div>
  );
};

export default QAModal;
